//
//
//
//
//
//
//
//
//

import { mdiCameraOutline } from '@mdi/js'

export default {
  setup() {
    return { icons: { mdiCameraOutline } }
  },
}
